if (!customElements.get('nc-plp-hero-slider')) {
  class NcPlpHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsContainer = this.querySelector('[data-dots]');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.speed, 10) || 5000;

      if (this.slides.length <= 1) {
        if (this.dotsContainer) this.dotsContainer.style.display = 'none';
        return;
      }

      this.createDots();
      this.startAutoplay();

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    createDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';

      this.slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `nc-plp-hero__dot${idx === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.addEventListener('click', () => {
          this.goToSlide(idx);
          this.restartAutoplay();
        });
        this.dotsContainer.appendChild(dot);
      });

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.nc-plp-hero__dot'));
    }

    goToSlide(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === index);
      });

      if (this.dots) {
        this.dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === index);
        });
      }

      this.currentIndex = index;
    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1);
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.nextSlide(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  customElements.define('nc-plp-hero-slider', NcPlpHeroSlider);
}
